import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const features = [
  {
    title: "More Accuracy",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l7 4v5c0 4.4-3 8.5-7 9-4-0.5-7-4.6-7-9V7l7-4Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9.5 12.5 11 14l3.5-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Saves Time & Cost",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Builds Brand Trust",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 10v8h16v-8M4 10l8-6 8 6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9 18v-4h6v4" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Automated Testing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 5l12 7-12 7V5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M19 5v14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Defect-Free Delivery",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "End-to-End Coverage",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 12h18M12 3c2.5 3 4 6 4 9s-1.5 6-4 9M12 3c-2.5 3-4 6-4 9s1.5 6 4 9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const StestWhyChoose: React.FC = () => {
  return (
    <section className="wdev-why" aria-labelledby="stest-why-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="stest-why-title" className="wdev-section-head__title">
            Why choose WebTech for software testing in Bangalore?
          </h2>
        </AnimatedSection>

        <div className="wdev-why__grid">
          {features.map((feature, index) => (
            <motion.article
              key={feature.title}
              className="wdev-why-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
            >
              <div className="wdev-why-card__icon">{feature.icon}</div>
              <h3 className="wdev-why-card__title">{feature.title}</h3>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StestWhyChoose;
